import { render, staticRenderFns } from "./QuickLinkTableAction.vue?vue&type=template&id=473c50fc"
import script from "./QuickLinkTableAction.vue?vue&type=script&lang=js"
export * from "./QuickLinkTableAction.vue?vue&type=script&lang=js"
import style0 from "./QuickLinkTableAction.vue?vue&type=style&index=0&id=473c50fc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports